import React from "react"
import { Link, graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Image from "../components/image"
import "../components/thoughts.css"
import FooterLinks from "../components/footerLinks"
import { formatThoughtDate, ThoughtsContact } from "../components/thoughts"
import thoughts from "../data/thoughts"

const ThoughtTemplate = ({ data, pageContext }) => {
  const thought = thoughts.find(item => item.slug === pageContext.slug)
  const { pageData } = data

  if (!thought) {
    return null
  }

  const pathname = `/thoughts/${thought.slug}/`

  return (
    <Layout showHeader={false}>
      <SEO
        title={thought.title}
        description={thought.description}
        pathname={pathname}
        type="article"
        datePublished={thought.date}
        keywords={[
          "Rahul Vagadiya",
          "product thinking",
          "AI",
          "building products",
        ]}
      />
      <div className="thoughts-site">
        <nav className="thoughts-nav" aria-label="Primary navigation">
          <Link className="thoughts-nav__brand" to="/">
            Rahul Vagadiya
          </Link>
          <Link className="thoughts-nav__link" to="/thoughts/">
            All thoughts
          </Link>
        </nav>

        <article className="thought-page">
          <header className="thought-page-header">
            <Link className="thought-back-link" to="/thoughts/">
              All thoughts <span aria-hidden="true">←</span>
            </Link>
            <time className="thought-date" dateTime={thought.date}>
              {formatThoughtDate(thought.date)}
            </time>
            <h1>{thought.title}</h1>
            <p>{thought.description}</p>
          </header>
          {thought.image && (
            <Image
              alt=""
              aria-hidden="true"
              fileName={thought.image}
              className="thought-image rv-rounded-md rv-overflow-hidden"
            />
          )}
          <div className="thought-page-content">
            {thought.body.map(paragraph => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
        </article>

        <ThoughtsContact />

        <footer className="thoughts-footer">
          <Link className="thought-home-link" to="/">
            Back to home <span aria-hidden="true">→</span>
          </Link>
          <FooterLinks links={pageData.siteMetadata.dev.links} />
        </footer>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query ThoughtTemplateQuery {
    pageData: site {
      siteMetadata {
        pages {
          home {
            name
            description
          }
        }
        dev {
          links {
            name
            url
            filename
            tooltip
            icon
          }
        }
      }
    }
  }
`

export default ThoughtTemplate
